import { Button } from '@/components/elements/forms/buttons';
import { _s } from '@/locale';
import { authorizeKlarnaPurchase, getInitializeKlarnaSDKOnce, loadKlarnaWidget } from '@/services/klarnaServices';
import { KPAuthorizationResponse } from '@/types/klarnaPayments';
import { useEffect } from 'react';

const baseTranslationKey = 'components.modules.checkout.KlarnaCheckout';

const KlarnaCheckout = ({
  clientToken,
  orderLines,
  submitLabel,
  handleCreateOrder,
}: {
  clientToken: string;
  orderLines: any[];
  submitLabel?: string;
  handleCreateOrder: (res: KPAuthorizationResponse) => void;
}) => {
  useEffect(() => {
    const initializeKlarnaSDK = getInitializeKlarnaSDKOnce();
    initializeKlarnaSDK();
    loadKlarnaWidget('#klarna-payment', clientToken);
  }, []);

  const payWithKlarna = () => {
    authorizeKlarnaPurchase(orderLines, 'pay_later', (res) => {
      if (res.authorization_token) {
        handleCreateOrder(res);
      }
    });
  };

  return (
    <>
      <div id="klarna-payment"></div>
      <Button variant="primary" block size="md" onClick={payWithKlarna}>
        {submitLabel ?? _s(`${baseTranslationKey}.payWithKlarna`)}
      </Button>
    </>
  );
};

export default KlarnaCheckout;
